import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import "./events-section.m.css";
import Chevron from "../../../../assets/icons/chevron";

const EventsSection = () => {
  const cdnHost = useSelector((state) => get(state, ["qt", "config", "cdn-image"]));
  const eventsBackgroundKey = useSelector((state) => get(state, ["qt", "config", "publisher-attributes","homePageData","eventsBackGroundKey"], {}));
  const eventsBackgroundUrl = `https://${cdnHost}/${eventsBackgroundKey}`;
  const eventCategories = [
    {
      title: "Sessions",
      description: "In-person and online sessions covering key business themes, across 6 cities and multiple Forums",
      url: "/events/sessions"
    },
    {
      title: "Conferences",
      description: "Annual/semi-annual, 2–4 day immersive meetings, tailored for individual C-suite cohorts",
      url: "/events/conferences"
    },
    {
      title: "Workshops",
      description: "1–2 day deep-dives into issues around strategy, people, policy and risk",
      url: "/events/workshops"
    }
  ];

  return (
    <div styleName="events-section" style={{backgroundImage: `url(${eventsBackgroundUrl})`, backgroundSize: 'cover'}}>
      <div
        styleName="hero-section"
      >
        <div styleName="hero-content">
          <div styleName="shoulder-tag">
            WHAT IMA OFFERS
          </div>
          <h2 styleName="hero-heading">
            Collaborate, Learn, Grow
          </h2>
        </div>
      </div>

      <div styleName="content-section">
        <div styleName="container">
          <div styleName="categories-grid">
            {eventCategories.map((category, index) => (
              <div key={index} styleName="category-card">
                <div styleName="category-header">
                  <a
                    href={category.url}
                    styleName="category-title"
                  >
                    {category.title}
                  </a>
                  <div styleName="arrow-icon">
                    <Chevron color="white" />
                  </div>
                </div>
                <p styleName="category-description">
                  {category.description}
                </p>
              </div>
            ))}
          </div>

          <div styleName="link-container">
            <a href="/events" styleName="explore-link">
              <span styleName="link-text">Explore events</span>
              <div styleName="arrow-icon">
                <Chevron color="#ff2626" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export { EventsSection };